import { render } from "./UpdateAnnouncementView.vue?vue&type=template&id=44e9f458"
import script from "./UpdateAnnouncementView.vue?vue&type=script&lang=js"
export * from "./UpdateAnnouncementView.vue?vue&type=script&lang=js"

import "./UpdateAnnouncementView.vue?vue&type=style&index=0&id=44e9f458&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__